
import { Element } from "@craftjs/core";
import { GitForkIcon } from "lucide-react";

import { ButtonBlock, ContainerBlock, FlexBlock, ProgressBarBlock, MidpathBlock, SectionBlock } from "..";
import { define } from "../../utils";
import BasePreview from "../base";

function MidpathContainer({ children, ...props }) {
  children = children || <Element canvas is={SectionBlock} id="section">
    <Element is={ContainerBlock} isCanvas>
      <Element id='progress-bar' is={ProgressBarBlock} />
      <Element is={FlexBlock} isCanvas properties={{
        layoutType: "flex",
        flex: { direction: 'flex-col', gap: '4', align: 'items-center' },
        size: { width: 'w-full' },
      }}>
        <Element is={MidpathBlock} />
        <Element is={ButtonBlock} properties={{
          customClassName: ["userenroll-next"],
          'customClassName-options': [{ label: "userenroll-next", value: "userenroll-next" }],
          content: "Host Submit Button ",
          tagName: 'button',
          background: { color: 'gray-100' },
          textColor: 'gray-900',
          space: { padding: 'py-2 px-3' },
          border: { radius: { rounded: "sm" } },
          cursor: 'cursor-pointer',
        }} />
        <Element is={ButtonBlock} properties={{
          customClassName: ["userenroll-next"],
          'customClassName-options': [{ label: "userenroll-next", value: "userenroll-next" }],
          content: "Host Skip Button",
          tagName: 'a',
          background: { color: 'transparent' },
          textColor: 'blue-500',
          cursor: 'cursor-pointer',
        }} />
      </Element>
    </Element>
  </Element>

  return <BasePreview {...props} >
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('midpath-container', MidpathContainer)
  .palete(<GitForkIcon size={16} />, 'Midpath', 'Embedded')
  .build()
